module.exports = __webpack_public_path__ + "static/media/13_before.e9cb485e.jpg";